/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useNavigate, Navigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {
  getUserByToken,
  login,
  emailVerification,
  forgotPassword,
  get_Account_Type,
} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import {GoogleLogin, GoogleLogout} from 'react-google-login'
import {gapi} from 'gapi-script'
import {Link} from 'react-router-dom'
import {ForgotPassword} from './ForgotPassword'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .max(50, 'Maximum 50 characters')
    .required('Email Required'),
  password: Yup.string()
    .min(8, 'Minimum 8 characters')
    .max(50, 'Maximum 50 symbols')
    .required('Password Required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const navigate = useNavigate()

  const [profile, setProfile] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [showForgotPassword, setShowForgotPassword] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const [blockUser, setBlockUser] = useState(false)
  const [loginStatus, setLoginStatus] = useState()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setStatus(false)
      setLoading(true)
      try {
        const {data: auth} = await login(values.email, values.password)

        if (auth.api_token) {
          localStorage.setItem('account_verified', auth.account_verified)
          try {
            const {data: response} = await get_Account_Type(auth.api_token)
            if (response.code === '200') {
              localStorage.setItem('user_type', response.data.userTypeName)
            } else {
              saveAuth(undefined)
              setStatus(response.msg_details)
              setSubmitting(false)
              setLoading(false)
            }
          } catch (error) {
            console.error(error)
            saveAuth(undefined)
            setStatus('Something went wrong')
            setSubmitting(false)
            setLoading(false)
          }

          saveAuth(auth)
          localStorage.setItem('api_token', auth.api_token)
          // navigate(
          //   '/auth/terms-conditions'
          // )

          saveAuth(auth)

          const {data: user} = await getUserByToken(auth.api_token)

          setCurrentUser(user)

          // navigate('/property')
        } else {
          if (auth.code == 500) {
            saveAuth(undefined)
            setStatus(auth.msg_details)
            setSubmitting(false)
            setLoading(false)
          }
        }
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })
  const clientId = process.env.REACT_APP_LOGIN_WITH_GOOGLE_CLIENTID
  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: clientId,
        scope: '',
      })
    }
    gapi.load('client:auth2', initClient)
  }, [])

  const onFailure = (err: any) => {
    console.log('failed:', err)
  }

  const signinOnSuccess = async (res: any) => {
    const {data: auth} = await emailVerification(res.profileObj.email)
    if (auth.api_token) {
      saveAuth(auth)
      localStorage.setItem('api_token', auth.api_token)
      localStorage.setItem('account_verified', auth.account_verified)
      const {data: user} = await getUserByToken(auth.api_token)
      try {
        const {data: response} = await get_Account_Type(auth.api_token)
        if (response.code === '200') {
          localStorage.setItem('user_type', response.data.userTypeName)
        } else {
          saveAuth(undefined)
          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setLoading(false)
      }
      setCurrentUser(user)
    } else {
      let googleStatus = 1
      navigate('/auth/registration-page', {
        state: {
          googleStatus: googleStatus,
          Uemail: res.profileObj.email,
          Uname: res.profileObj.givenName,
        },
      })
    }
  }

  const handleForgotPassword = async () => {
    setShowForgotPassword(true)
  }
  return (
    <>
      {showForgotPassword ? (
        <ForgotPassword setShowForgotPassword={setShowForgotPassword} />
      ) : (
        <form
          className='form w-100'
          onSubmit={formik.handleSubmit}
          noValidate
          id='kt_login_signin_form'
        >
          {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
          )}
          {/* begin::Heading */}
          <div className='text-center mb-11'>
            <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>
          </div>

          <div className='text-gray-500 text-center fw-semibold fs-6'>
            {/*   {profile ? ( 
          <div>
            <img src={profile.imgURL} alt="user image" />
                    <h3>User Logged in</h3>
                    <p>Name: {profile.name}</p>
                    <p>Email Address: {profile.email}</p>
                    <GoogleLogout clientId={clientId} buttonText="Log out" onLogoutSuccess={logOut} />
                    </div>
           ) : (  */}
            {clientId && (
              <GoogleLogin
                clientId={clientId}
                className='bg-light rounded hover-scale'
                buttonText='Sign in or Sign up with Google'
                onSuccess={signinOnSuccess}
                onFailure={onFailure}
                cookiePolicy={'single_host_origin'}
                //isSignedIn={true}
              />
            )}
          </div>

          {/* begin::Separator */}
          <div className='separator separator-content my-14'>
            <span className='w-125px text-gray-500 fw-semibold fs-7'>
              Or
              <br /> with email
            </span>
          </div>
          {/* end::Separator */}

          {/* begin::Form group */}
          <div className='fv-row mb-8'>
            <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
            <input
              placeholder='Email'
              {...formik.getFieldProps('email')}
              className={clsx(
                'form-control bg-transparent',
                {'is-invalid': formik.touched.email && formik.errors.email},
                {
                  'is-valid': formik.touched.email && !formik.errors.email,
                }
              )}
              type='email'
              name='email'
              autoComplete='off'
            />
            {formik.touched.email && formik.errors.email && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.email}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='fv-row'>
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
            <div className='position-relative'>
              <input
                type={showPassword ? 'text' : 'password'}
                autoComplete='off'
                placeholder='Password'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control bg-transparent',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  },
                  {
                    'right-padding': formik.touched.password,
                  }
                )}
              />
              <div
                className={`position-absolute end-0 top-0 py-3 px-2 ${
                  formik.touched.password && 'me-10'
                }`}
                style={{fontWeight: '600'}}
              >
                {showPassword ? (
                  <i
                    className='bi bi-eye-fill fs-1 text-primary'
                    onClick={() => setShowPassword(false)}
                  ></i>
                ) : (
                  <i
                    className='bi bi-eye-slash-fill fs-1 text-primary'
                    onClick={() => setShowPassword(true)}
                  ></i>
                )}
              </div>
            </div>
            <div className='d-flex justify-content-between'>
            
              <div className='fv-plugins-message-container'>
                {formik.touched.password && formik.errors.password && (
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.password}</span>
                  </div>
                )}
              </div>
              <div
                className='text-muted text-right pt-1'
                style={{fontWeight: '600', textAlign: 'right'}}
              >
                <span style={{cursor: 'pointer'}} onClick={handleForgotPassword}>
                  Forgot password?
                </span>
              </div>
            </div>
          </div>
          {/* end::Form group */}
          
          {/* begin::Wrapper */}
          <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
            <div />

            {/* begin::Link */}
            {/* <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link> */}
            {/* end::Link */}
          </div>
          {/* end::Wrapper */}

          {/* begin::Action */}
          <div className='d-grid mb-10'>
            <button
              type='submit'
              id='kt_sign_in_submit'
              className='btn btn-primary rounded hover-scale'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {!loading && <span className='indicator-label'>Continue</span>}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
          {/* end::Action */}

          <div className='text-gray-500 text-center fw-semibold fs-6'>
            Not a member yet? {/* <Link to='/auth/signup' className='link-primary'> */}
            <Link to='/auth/registration-page' className='link-primary'>
              Sign up
            </Link>
          </div>
          <div className='text-gray-500 text-center fw-semibold fs-6 mt-4'>
            {/* <GoogleLogin
          clientId={clientId}
          buttonText="Sign Up with Google"
          onSuccess={onSuccess}
          onFailure={onFailure}
          cookiePolicy={'single_host_origin'}
          //isSignedIn={true}
      /> */}
          </div>
          {/* 
      <div className='text-gray-500 text-center fw-semibold fs-6'> */}

          {/* <Link to='/auth/signup' className='link-primary'> */}
          {/* <Link to='/auth/registration-page' className='link-primary'>
         test
        </Link>
      </div> */}
        </form>
      )}
    </>
  )
}
